// REFACTOR: Load dynamically from server: don't hardcode database values.
// Maybe create a new Redux entity called `attributeTypes`.
const typeNames = {
  STRING: 'Text',
  EMAIL: 'Email',
  DATE: 'Date',
  NUMBER: 'Number',
  BOOLEAN: 'Boolean',
};

const keys = {
  STRING: 'STRING',
  EMAIL: 'EMAIL',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
};

export { typeNames, keys };
